import React from 'react';
import CRMBoard from '../../components/admin-dashboard/crm/CRMBoard';

const InternshipCRM = () => {
  return <CRMBoard pipelineType="internship" />;
};

export default InternshipCRM;
